module.exports = __webpack_public_path__ + "static/media/skills_homepage.2ac65fd4.png";